import { render, staticRenderFns } from "./DialogQuestionPosObjectives.vue?vue&type=template&id=07e4ede6"
import script from "./DialogQuestionPosObjectives.vue?vue&type=script&lang=js"
export * from "./DialogQuestionPosObjectives.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports